import React from 'react';

import styled from 'styled-components';

import { DataContext } from '../DataProvider';
import Lesson from '../Lesson';

function Section({ sectionLookup, title, lessons, initialIsOpen }) {
  const [forceOpen, setForceOpen] = React.useState(false);
  const [forceOpenWasClicked, setForceOpenWasClicked] = React.useState(false);

  const handleClick = () => {
    setForceOpen((previous) => {
      if (!forceOpenWasClicked && initialIsOpen) {
        return false;
      }
      return !previous;
    });
    setForceOpenWasClicked(true);
  };

  return (
    <SectionDiv>
      <SectionHeader selected={initialIsOpen}>
        <button onClick={handleClick}>{title}</button>
      </SectionHeader>
      {((!forceOpenWasClicked && initialIsOpen) || forceOpen) && (
        <>
          {lessons.map((lesson, index) => (
            <Lesson
              key={lesson.episode_number}
              sectionLookup={sectionLookup}
              item={lesson}
            />
          ))}
        </>
      )}
    </SectionDiv>
  );
}

export default Section;

const SectionHeader = styled.div`
  padding: 28px 16px;
  font-size: 18px;
  font-weight: bold;
  color: #e1e1e1;
  // #262626
  background-color: #1a1a1a;
  background-color: ${({ selected }) => (selected ? '#363636' : '#1a1a1a')};
  margin-bottom: 3px;
`;

const SectionDiv = styled.div`
  &:first-of-type {
    margin-top: 20px;
  }
`;
